module.exports = __webpack_public_path__ + "img/layout-6_2.6a1f98b6.png";